import * as emailValidator from '@rategravity/core-lib/validate-email';
import React from 'react';
import SessionCard from '../../components/card/session-card';
import hubspot from '../../modules/hubspot';
import { ContactInfo, nameValidator } from '.';

const ManufacturedMobileShortCard = ({ model, onChange, onSubmit, ...props }) => (
  <ContactInfo
    {...props}
    onSubmit={
      onSubmit &&
      (() => {
        hubspot.registerManufacturedMobileLead(model.getIn(['borrower', 'email']), {
          name: model.getIn(['borrower', 'name']),
          scenario: model.getIn(['loan', 'scenario']),
          /* eslint-disable @typescript-eslint/camelcase */
          loan_state:
            model.getIn(['loan', 'preapprovalState']) || model.getIn(['loan', 'loanState']),
          loan_property_type: model.getIn(['loan', 'propertyType'])
          /* eslint-enable @typescript-eslint/camelcase */
        });
        onSubmit();
      })
    }
    model={model.get('borrower')}
    onChange={onChange.bind(null, 'borrower')}
    buttonType="end"
    title={`Unfortunately, our lenders don't offer loans for ${model
      .getIn(['loan', 'propertyType'])
      .toLowerCase()} homes at this time. Please leave us your email and we’ll send you a note when that changes.`}
    complete={!!ManufacturedMobileShortCard.completed({ model })}
  />
);

ManufacturedMobileShortCard.id = 'ManufacturedMobileShortCard';
ManufacturedMobileShortCard.completed = ({ model }) =>
  nameValidator(model.getIn(['borrower', 'name'])) &&
  emailValidator.validate(model.getIn(['borrower', 'email']) || '');

export const ManufacturedMobileContactInfo = SessionCard(ManufacturedMobileShortCard);



// WEBPACK FOOTER //
// ./src/cards/contact-info-short/manufactured-mobile.js